import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogHostDirective } from './dialog-host.directive';
import { DialogComponent } from './dialog.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [DialogComponent, DialogHostDirective],
    declarations: [DialogComponent, DialogHostDirective],
    providers: [],
})
export class DialogModule { }
